import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-beb100e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overflow-hidden" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Description", -1))
const _hoisted_3 = { class: "mt-3 flex-row flex -mx-2" }
const _hoisted_4 = { class: "flex flex-col w-1/2 px-2" }
const _hoisted_5 = {
  for: "created-by",
  class: "mb-2"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "flex flex-col w-1/2 px-2" }
const _hoisted_8 = {
  for: "requested-by",
  class: "mb-2"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "mt-3 flex-row flex -mx-2" }
const _hoisted_11 = { class: "flex flex-col w-1/2 px-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "valid-from",
  class: "mb-2"
}, "Valid from", -1))
const _hoisted_13 = { class: "flex flex-col w-1/2 px-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "valid-to",
  class: "mb-2"
}, "Valid to", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert = _resolveComponent("alert")!
  const _component_date_picker = _resolveComponent("date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.areDatesInvalid)
      ? (_openBlock(), _createBlock(_component_alert, {
          key: 0,
          class: "mb-4",
          content: "Invalid dates"
        }))
      : _createCommentVNode("", true),
    (_ctx.isDescriptionEmpty)
      ? (_openBlock(), _createBlock(_component_alert, {
          key: 1,
          class: "mb-4",
          content: _ctx.$t('proposal.settings.description_required')
        }, null, 8, ["content"]))
      : _createCommentVNode("", true),
    (_ctx.areInitialsEmpty)
      ? (_openBlock(), _createBlock(_component_alert, {
          key: 2,
          class: "mb-4",
          content: _ctx.$t('proposal.settings.initials_required')
        }, null, 8, ["content"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _hoisted_2,
      _withDirectives(_createElementVNode("textarea", {
        id: "description",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localDescription) = $event)),
        class: "default-input mt-2 description-field"
      }, null, 512), [
        [_vModelText, _ctx.localDescription]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('proposal.settings.created_by')), 1),
        _withDirectives(_createElementVNode("input", {
          id: "created-by",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localCreatedBy) = $event)),
          type: "text",
          maxlength: "10",
          class: "default-input initials-field",
          disabled: !_ctx.isProposalEditable
        }, null, 8, _hoisted_6), [
          [_vModelText, _ctx.localCreatedBy]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('proposal.settings.requested_by')), 1),
        _withDirectives(_createElementVNode("input", {
          id: "requested-by",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localRequestedBy) = $event)),
          type: "text",
          maxlength: "10",
          class: "default-input initials-field",
          disabled: !_ctx.isProposalEditable
        }, null, 8, _hoisted_9), [
          [_vModelText, _ctx.localRequestedBy]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_date_picker, {
          id: "valid-from",
          value: _ctx.localValidFrom,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localValidFrom) = $event)),
          disabled: !_ctx.isProposalEditable,
          format: "DD.MM.YYYY",
          lang: "pl"
        }, null, 8, ["value", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode(_component_date_picker, {
          id: "valid-to",
          value: _ctx.localValidTo,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localValidTo) = $event)),
          disabled: !_ctx.isProposalEditable,
          format: "DD.MM.YYYY",
          lang: "pl"
        }, null, 8, ["value", "disabled"])
      ])
    ])
  ]))
}